var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form/dist/index.ie11';
import { Container, PageHeading, Section, Heading, Input, FormField, Button, InputList } from '../../shared';
import { services, validation } from '../../../shared';
import './profile.scss';
export var ProfilePage = function (_a) {
    var _b, _c, _d, _e;
    var broker = _a.broker, setBroker = _a.setBroker;
    var _f = useState([]), jobTitles = _f[0], setJobTitles = _f[1];
    var _g = useForm({}), register = _g.register, handleSubmit = _g.handleSubmit, setValue = _g.setValue, formState = _g.formState, errors = _g.errors;
    var fetchJobTitles = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getjobTitles()];
                case 1:
                    res = (_a.sent()).data;
                    setJobTitles(res);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var newBroker, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newBroker = __assign(__assign({}, broker), { name: "".concat(data.firstName, " ").concat(data.lastName), jobTitleId: Number(data.jobTitle), telephone: data.contactNumber });
                    return [4 /*yield*/, services.UpdateBroker(newBroker)];
                case 1:
                    response = _a.sent();
                    if (!response.error) {
                        setBroker(newBroker);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchJobTitles();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { headingLevel: 2, title: "Profile", icon: "user", mb: 6 }),
        React.createElement(Container, { extendClass: "c-profile-form" },
            React.createElement(Section, { headerChildren: React.createElement(Heading, { level: 'h2', title: 'Personal Details' }) },
                React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true },
                    React.createElement("fieldset", null,
                        React.createElement("legend", null, "Personal Details"),
                        React.createElement(FormField, { id: "firstName", label: "First Name", error: errors.firstName && validation.firstName.message },
                            React.createElement(Input, { id: "firstName", value: (_c = (_b = broker === null || broker === void 0 ? void 0 : broker.name) === null || _b === void 0 ? void 0 : _b.split(' ')[0]) !== null && _c !== void 0 ? _c : '', setValue: setValue, error: !!errors.firstName, required: validation.firstName.types.required, ref: register(validation.firstName.types) })),
                        React.createElement(FormField, { id: "lastName", label: "Last Name", error: errors.lastName && validation.lastName.message },
                            React.createElement(Input, { id: "lastName", value: (_e = (_d = broker === null || broker === void 0 ? void 0 : broker.name) === null || _d === void 0 ? void 0 : _d.split(' ')[1]) !== null && _e !== void 0 ? _e : '', setValue: setValue, error: !!errors.lastName, required: validation.lastName.types.required, ref: register(validation.lastName.types) })),
                        React.createElement(FormField, { label: "Job Title", error: errors.jobTitle && validation.title.message },
                            React.createElement(InputList, { id: "jobTitle", options: jobTitles, value: broker === null || broker === void 0 ? void 0 : broker.jobTitleId.toString(), setValue: setValue, legend: "Select a Jobtitle", error: !!errors.jobTitle, required: validation.title.types.required, ref: register(validation.title.types) })),
                        React.createElement(FormField, { id: "contactNumber", label: "Mobile Number", error: errors.contactNumber && validation.contactNumber.message },
                            React.createElement(Input, { type: "tel", id: "contactNumber", value: broker === null || broker === void 0 ? void 0 : broker.telephone, setValue: setValue, required: validation.contactNumber.types.required, error: !!errors.contactNumber, ref: register(validation.contactNumber.types) })),
                        React.createElement(Button, { type: "submit", variant: "primary", childClasses: "u-mr-2", disabled: !formState.isDirty }, "Update details")))))));
};
